<template>
  <sidebar-row border-bottom>
    <template #actionIcon>
      <v-icon :color="attachment.iconColor" style="font-size: 28px">
        {{ attachment.icon }}
      </v-icon>
    </template>

    <v-row no-gutters class="py-4">
      <v-col>
        <v-tooltip
          left
          content-class="pa-0"
          color="rgba(255,255,255,0)"
          :disabled="!attachment.is_photo"
          :allow-overflow="true"
        >
          <template #activator="{ on }">
            <p
              class="ma-0 pl-1"
              style="text-align: left; font-size: 12px; line-height: 14px; font-weight: normal; color: #202124"
              v-on="on"
            >
              {{ attachment.name }}
            </p>
          </template>
          <img :src="attachment.thumbnailUrl" :alt="attachment.name" />
        </v-tooltip>
        <italic-subheader
          class="pl-1"
          :straight-text="attachment.subheader"
          style="font-size: 10px !important;"
        ></italic-subheader
      ></v-col>
      <v-col cols="1">
        <dots-menu
          :items="attachment.dotsItems"
          @setProfileImage="setProfileImage"
          @delete="openDialog(attachment)"
          @download="downloadAttachment(attachment.id)"
          font-size="18px"
        >
        </dots-menu>
      </v-col>
    </v-row>
  </sidebar-row>
</template>

<script>
import { call, get } from 'vuex-pathify';
import prepareAttributesFeatureCardMixin from '@/mixins/prepareAttributesFeatureCardMixin';
import ItalicSubheader from '@/components/ItalicSubheader';
import DotsMenu from '@/components/DotsMenu';
import SidebarRow from '@/components/SidebarRow';

export default {
  name: 'TheAttachment',
  components: { SidebarRow, ItalicSubheader, DotsMenu },
  mixins: [prepareAttributesFeatureCardMixin],
  props: {
    attachment: {
      type: Object,
      required: true,
    },
    layerId: {
      type: [String, Number],
      required: true,
    },
    featureId: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    currentLayer: get('layers/layers@:layerId'),
  },
  methods: {
    downloadAttachment: call('relations/downloadAttachment'),
    editDatasourceFeature: call('layers/editDatasourceFeature'),
    openDialog(file) {
      this.$emit('deleteFile', file);
    },
    async setProfileImage() {
      await this.editDatasourceFeature({
        datasource: this.currentLayer.data_source_name,
        id: this.featureId,
        body: {
          ...this.getValues(this.currentLayerFormSchema, {}),
          [this.currentLayer.image_attribute]: this.attachment.fileUrl,
        },
        params: { layer_id: this.currentLayer.id },
      });
      this.$root.$emit('refreshTableData');
      this.$root.$emit('refreshFormData');
    },
  },
};
</script>

<style scoped lang="scss"></style>
